<template>
  <div>
    <finance-summery module_id="52" v-model="maximizeCard"></finance-summery>
    <vs-card class="cstm_vx_card mb-4">
      <vs-row class="mt-2">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input
              placeholder="Search"
              class="w-full"
              v-model="search"
              @keyup="searchFun"
              style="width: 100%"
            />
          </div>
          <div class="md:w-1/2 w-full p-1">
            <v-select
              v-model="selectedInvoiceFor"
              class="w-full"
              label="name"
              :options="invoiceForList"
              :reduce="item => item.name"
              :clearable="false"
              placeholder="Invoice For"
            >
            </v-select>
          </div>
          <div class="md:w-1/2 w-full p-1">
            <v-select
              append-to-body
              class="w-full"
              label="name"
              v-model="selectedPaymentStatus"
              placeholder="Payment Status"
              :reduce="option => option.id"
              :options="paymentStatusList"
              :clearable="false"
            >
            </v-select>
          </div>
          <div class="p-1 flex">
            <vs-button
              @click="searchByfilter"
              class="includeIcon includeIconOnly"
              >Go</vs-button
            >

            <vs-tooltip text="Reset">
              <vs-button
                type="border"
                @click="resetSearch"
                icon-pack="feather"
                icon="icon-refresh-ccw"
                class="ml-2"
              ></vs-button>
            </vs-tooltip>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-lg="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-button @click="addManualInvice">Create</vs-button>
        </vs-col>
      </vs-row>
    </vs-card>

    <ag-grid-vue
      ref="agGridTable"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :style="{ minHeight: meta.limit * 48 + 75 + 'px' }"
      :gridOptions="gridOptions"
      :animateRows="true"
      :floatingFilter="false"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="invoiceList"
      @grid-ready="onGridReady"
      @sortChanged="sortFun"
    />
    <div class="sm:flex justify-between items-center">
      <ItemsPerTableDropdown
        tableName="manual_invoice_list"
        @change="pageLimit => (pageLimitSet = pageLimit)"
      />
      <pagination
        :meta="meta"
        @page-change="handlePageChange"
        class="ml-auto"
      />
    </div>

    <div
      class="full-cstm-sidebar mt-107"
      v-if="invoiceDetails !== null"
      :class="{ open: notiSidebar }"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>Invoice Details</h4>
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click="handleViewSidebar"
        />
      </div>
      <vs-divider class="mb-0" />
      <div class="p-6 pt-2 sidebar-scrollable-form">
        <img
          src="@/assets/images/logo/web-logo.png"
          style="height: 80px; object-fit: contain"
        />
        <div class="flex items-center justify-between">
          <div>
            <strong>Date Issued: </strong>
            <p>{{ invoiceDetails.invoice_date }}</p>
          </div>
        </div>
        <vs-divider />

        <vs-row>
          <vs-col
            v-if="invoiceDetails.invoice_for !== 'SELF'"
            class="px-4"
            vs-lg="6"
            vs-sm="12"
            vs-xs="12"
          >
            <strong>Bill from</strong>
            <p class="my-2">
              <span
                >{{ invoiceDetails.bill_from_details.first_name }}
                {{ invoiceDetails.bill_from_details.middle_name }}
                {{ invoiceDetails.bill_from_details.last_name }}</span
              >
            </p>
            <p>{{ invoiceDetails.bill_from_details.email }}</p>
            <p>{{ invoiceDetails.bill_from_details.phone }}</p>
            <address>
              {{ invoiceDetails.bill_from_details.address.address1 }}
            </address>
            <p>{{ invoiceDetails.bill_from_details.address.address2 }}</p>
            <p>{{ invoiceDetails.bill_from_details.address.city }}</p>
            <p>{{ invoiceDetails.bill_from_details.address.country }}</p>
            <p>{{ invoiceDetails.bill_from_details.address.state }}</p>
            <p>{{ invoiceDetails.bill_from_details.address.zip }}</p>
          </vs-col>
          <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
            <strong>Bill to</strong>
            <p class="my-2">
              {{ invoiceDetails.user_details.first_name }}
              {{ invoiceDetails.user_details.middle_name }}
              {{ invoiceDetails.user_details.last_name }}
            </p>
            <p>{{ invoiceDetails.user_details.email }}</p>
            <p>{{ invoiceDetails.user_details.phone }}</p>
            <address>
              {{ invoiceDetails.bill_address.address1 }}
            </address>
            <p>{{ invoiceDetails.bill_address.address2 }}</p>
            <p>{{ invoiceDetails.bill_address.city }}</p>
            <p>{{ invoiceDetails.bill_address.country }}</p>
            <p>{{ invoiceDetails.bill_address.state }}</p>
            <p>{{ invoiceDetails.bill_address.zip }}</p>
          </vs-col>
        </vs-row>
        <vs-divider />

        <div class="table-responsive cstm_vuexy_table">
          <table class="item_list_table">
            <thead>
              <tr>
                <th style="min-width: 160px">Product / Service</th>
                <th style="min-width: 250px">Description</th>
                <th style="width: 120px">Qty</th>
                <th style="min-width: 100px">Unit Price</th>
                <th style="min-width: 105px">Total Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in invoiceDetails.items" :key="index">
                <td>{{ item.item_name }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.unit_price }}</td>
                <td>{{ item.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-right mt-2">
          <vs-row>
            <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
              <strong>Total</strong>
            </vs-col>
            <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
              <span
                class="inline-block mr-1"
                v-html="invoiceDetails.currency_code"
              ></span
              ><strong>{{ calculateSubtotal }}</strong>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
              <strong>Tax</strong>
            </vs-col>
            <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
              <strong>{{ invoiceDetails.tax }} %</strong>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
              <strong>Grand Total</strong>
            </vs-col>
            <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
              <span
                class="inline-block mr-1"
                v-html="invoiceDetails.currency_code"
              ></span
              ><strong>{{ invoiceDetails.grand_total }}</strong>
            </vs-col>
          </vs-row>
        </div>

        <vs-divider />

        <div class="text-right mt-2">
          <vs-button class="mx-1" @click="downloadPdf"
            >Download as PDF</vs-button
          >
        </div>
      </div>
    </div>
    <div class="bg-overlay"></div>
    <vs-popup title="Delete Invoice" :active.sync="deletepopupflag">
      <vs-row>
        <span>Are you sure to delete Invoice?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="deleteManualInvoice"
          color="primary"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Confirm</vs-button
        >
        <vs-button @click="deletepopupflag = false" type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup title="Share Invoice" :active.sync="sharepopupflag">
      <vs-row>
        <span>Are you sure to share Invoice?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="shareManualInvoice"
          color="primary"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Confirm</vs-button
        >
        <vs-button @click="sharepopupflag = false" type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup title="Connect With Quickbook" :active.sync="connectpopupflag">
      <vs-row>
        <span>You have to connect with quickbook first to edit this</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="
            $router
              .push({
                name: 'page-user-settings',
                query: { tab: 11 }
              })
              .catch(() => {})
          "
          color="primary"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Connect Now</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import axios from 'axios'
import { quickbooksStatus } from '@/api/common'
import FinanceSummery from '../analytics/summeryLIst'
import vSelect from 'vue-select'
import {
  manualInvoiceList,
  deleteManualInvoice,
  updatePaymentStatus,
  shareManualInvoice,
  showManualInvoice,
  getPdfDownload,
  fetchManualFinanceBySearch
} from '@/api/manual-invoice'
import { AgGridVue } from 'ag-grid-vue'
import InvoiceNumberCell from './InvoiceNumberCell.vue'
import FullNameCell from './FullNameCell.vue'
import AmountCell from './AmountCell.vue'
import PaymentStatusCell from './PaymentStatusCell.vue'
import ShareCell from './ShareCell.vue'
import ActionsCell from './ActionsCell.vue'
import Pagination from '@/components/common/pagination'
export default {
  components: {
    vSelect,
    Pagination,
    FinanceSummery,
    AgGridVue,
    InvoiceNumberCell,
    FullNameCell,
    AmountCell,
    PaymentStatusCell,
    ShareCell,
    ActionsCell
  },
  data () {
    return {
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      gridApi: null,
      gridOptions: {
        accentedSort: true
      },
      search: '',
      connectpopupflag: false,
      selectedInvoiceFor: '',
      selectedPaymentStatus: null,
      invoiceForList: [
        { id: 1, name: 'SELF' },
        { id: 2, name: 'CLIENT' }
      ],
      paymentStatusList: [
        { id: 1, name: 'Paid' },
        { id: 2, name: 'Unpaid' }
      ],
      invoiceDetails: null,
      sharepopupflag: false,
      invoiceDeletedId: [],
      deletepopupflag: false,
      qbInvoiceId: null,
      quickbookConnected: false,
      columnDefs: [
        {
          headerName: 'Full Name',
          field: 'fullname',
          cellRendererFramework: 'FullNameCell',
          sortable: false
        },
        {
          headerName: 'Invoice #',
          field: 'invoice_number',
          cellRendererFramework: 'InvoiceNumberCell',
          CellRendererParams: {
            openViewSidebar: data => this.openViewSidebar(data)
          }
        },
        {
          headerName: 'Invoice For',
          field: 'invoice_for'
        },
        {
          headerName: 'Email',
          field: 'user_details.email'
        },
        {
          headerName: 'Invoice Creation Date',
          field: 'invoice_date'
        },
        {
          headerName: 'Due Date',
          field: 'due_date'
        },
        {
          headerName: 'Total Amount',
          field: 'total_amount',
          cellRendererFramework: 'AmountCell'
        },
        {
          headerName: 'Payment Status',
          field: 'status',
          minWidth: 180,
          maxWidth: 180,
          comparator:(value)=>{},
          cellRendererFramework: 'PaymentStatusCell',
          CellRendererParams: {
            changeStatus: data => this.changeStatus(data)
          }
        },
        {
          headerName: 'Share',
          field: 'share',
          sortable: false,
          minWidth: 90,
          maxWidth: 90,
          cellRendererFramework: 'ShareCell',
          CellRendererParams: {
            shareManualInvoiceConfirm: data => this.shareManualInvoiceConfirm(data)
          }
        },
        {
          headerName: 'Actions',
          field: 'action',
          sortable: false,
          minWidth: 100,
          maxWidth: 100,
          cellRendererFramework: 'ActionsCell',
          CellRendererParams: {
            addManualInvice: (data, bool_val) => this.addManualInvice(data, bool_val),
            deleteManualInvoiceConfirm: data => this.deleteManualInvoiceConfirm(data)
          }
        }
      ],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 20
      },
      pageLimitSet: null,
      invoiceList: [],
      maximizeCard: true,
      notiSidebar: false,
      addSideBar: false,
      name: '',
      description: '',
      unit: null,
      unitPrice: null,
      paymentStatus: [
        { id: 1, paymentName: 'Paid' },
        { id: 2, paymentName: 'Unpaid' }
      ]
    }
  },
  computed: {
    calculateSubtotal () {
      let subtotal = 0
      this.invoiceDetails.items.map(item => {
        subtotal += item.total
      })
      return subtotal
    }
  },
  beforeRouteLeave (to, from, next) {
    this.addSideBar = false
    this.notiSidebar = false
    setTimeout(() => {
      next()
    }, 0)
  },
  created () {
    this.fetchStatusForQuickbook()
  },
  // mounted () {
  //   this.gridApi = this.gridOptions.api
  // },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  methods: {
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId == 'invoice_number') {
        field_name = 'id'
      } else if (colId == 'user_details.email') {
        field_name = 'email'
      } else if (colId == 'total_amount') {
        field_name = 'grand_total'
      }
      return field_name
    },
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        console.log(sortState)
        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          //this.sorting_obj.attribute =sortState[0].colId
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort

          this.fetchInvoiceListBySearch()
        }
      } catch (e) {}
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      try {
        const payload = {
          search: vm.search,
          customer_id: vm.$store.getters.customerId
        }

        const responseData = await fetchManualFinanceBySearch(
          payload,
          vm.query_page,
          vm.sorting_obj
        )

        vm.invoiceList = responseData.data.data.invoice
        vm.meta = responseData.data.data.meta
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    async searchByfilter () {
      try {
        const payload = {
          invoice_for: this.selectedInvoiceFor,
          invoice_payment_status: this.selectedPaymentStatus
        }
        this.manualInvoiceList(payload)
      } catch (e) {
        //
      }
    },
    resetSearch () {
      this.search = null
      this.selectedInvoiceFor = ''
      this.selectedPaymentStatus = null
      this.handlePageChange(1)
    },
    async fetchStatusForQuickbook () {
      const { data } = await quickbooksStatus(
        localStorage.getItem('customer_id')
      )
      if (data.data[0] !== null) {
        this.quickbookConnected = data.data.status
      }
    },
    async changeStatus (invoiceData) {
      try {
        const payload = {
          invoice_id: invoiceData.invoice_id
        }
        const data = await updatePaymentStatus(payload)
        const objIndex = this.invoiceList.findIndex(
          obj => obj.invoice_id === invoiceData.invoice_id
        )
        if (invoiceData.invoice_payment_status_id === 1) {
          this.invoiceList[objIndex].invoice_payment_status = 'Paid'
        } else {
          this.invoiceList[objIndex].invoice_payment_status = 'Unpaid'
        }

        this.successPopupMessage('Status Updated successfully')
      } catch (e) {
        this.warningPopupMessage('something went wrong')
      }
    },
    async openViewSidebar (id) {
      try {
        const { data } = await showManualInvoice(
          localStorage.getItem('customer_id'),
          id
        )
        this.invoiceDetails = data.data.invoice
        this.notiSidebar = true
      } catch (e) {
        //
      }
    },
    handleViewSidebar () {
      this.notiSidebar = false
    },
    addManualInvice (fetchedData = null, edit = false) {
      if (edit === true) {
        // eslint-disable-next-line eqeqeq
        if (
          fetchedData.qb_invoice_id != null &&
          this.quickbookConnected === false
        ) {
          this.connectpopupflag = true
        } else {
          const QueryParams = {
            type: 'edit',
            id: fetchedData.invoice_id
          }
          this.$router
            .push({
              name: 'manual-invoice-form',
              query: QueryParams
            })
            .catch(() => {})
        }
      } else {
        const QueryParams = {
          type: 'create'
        }
        this.$router
          .push({
            name: 'manual-invoice-form',
            query: QueryParams
          })
          .catch(() => {})
      }
    },
    async downloadPdf () {
      const payload = {
        id: this.invoiceDetails.invoice_id
      }
      console.log(payload)
      const { data } = await getPdfDownload(payload)
      this.downloadItem({ url: data.data.url, label: data.data.name })
    },
    downloadItem ({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'mime' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${
            url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    async handlePageChange (page) {
      if (!this.pageLimitSet) return

      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      this.query_page.limit = this.pageLimitSet
      queryPayload.limit = this.query_page.limit
      this.query_page.page = page
      //const pageScroll = document.documentElement.scrollTop
      /* this.$router
        .replace({ path: '/pages/manual-invoice', query: queryPayload })
        .catch(() => {}).then(() => {
          document.documentElement.scrollTop = pageScroll
        }) */

      if (this.search !== '' || this.sorting_obj.attribute !== '') {
        this.fetchInvoiceListBySearch()
      } else if (this.search === '' || this.selectedPaymentStatus !== '' || this.invoiceForList !== '') {
        this.searchByfilter()
      } else {
        this.fetchInvoiceListBySearch()
      }
    },
    async fetchInvoiceListBySearch () {
      this.$vs.loading({
        text: 'Fetching Manual Invoice'
      })
      try {
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId
        }
        this.$vs.loading({
          text: 'Loading...'
        })
        const responseData = await fetchManualFinanceBySearch(
          payload,
          this.query_page,
          this.sorting_obj
        )
        this.invoiceList = responseData.data.data.invoice
        this.meta = responseData.data.data.meta
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    async manualInvoiceList (payload = {}) {
      this.$vs.loading({
        text: 'Fetching Manual Invoice'
      })
      try {
        const { data } = await manualInvoiceList(
          localStorage.getItem('customer_id'),
          this.query_page,
          payload
        )
        this.invoiceList = data.data.invoice
        this.meta = data.data.meta
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    shareManualInvoiceConfirm (data) {
      this.invoiceDeletedId.push(data.invoice_id)
      this.sharepopupflag = true
    },
    async shareManualInvoice () {
      try {
        this.sharepopupflag = false
        const payload = {
          invoice_id: this.invoiceDeletedId[0]
        }
        const data = await shareManualInvoice(payload)
        const objIndex = this.invoiceList.findIndex(
          obj => obj.invoice_id === this.invoiceDeletedId[0]
        )
        this.invoiceList[objIndex].is_shared_to_client = 1
        this.successPopupMessage('Invoice Shared successfully')
      } catch (e) {
        this.sharepopupflag = false
        this.warningPopupMessage('something went wrong')
      }
    },
    deleteManualInvoiceConfirm (data) {
      this.invoiceDeletedId = [data.invoice_id]
      this.qbInvoiceId = data.qb_invoice_id
      this.deletepopupflag = true
    },
    async deleteManualInvoice () {
      this.$vs.loading()
      try {
        this.deletepopupflag = false
        const payload = {
          invoice_ids: this.invoiceDeletedId,
          qb_invoice_id: this.qbInvoiceId
        }
        const data = await deleteManualInvoice(
          localStorage.getItem('customer_id'),
          payload
        )
        this.invoiceList = this.invoiceList.filter(item => {
          return item.invoice_id !== this.invoiceDeletedId[0]
        })

        if (this.invoiceList.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }

        this.successPopupMessage('Invoice deleted successfully')
        this.$vs.loading.close()
      } catch (e) {
        this.deletepopupflag = false
        this.warningPopupMessage('something went wrong')
        this.$vs.loading.close()
      }
    },
    successPopupMessage (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    warningPopupMessage (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  }
}
</script>
